import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

import { formatMoney, formatPrice, formatPriceRounded } from '@peach/types/utils/currencies.js';

dayjs.extend(utc);
dayjs.extend(timezone);

export { formatMoney, formatPrice };

/**
 * formatPrice for tight chrome (the sidebar/menu badges): cents are dropped,
 * and four digits and up compact to "$6.9K" — a badge is a teaser, the exact
 * figure lives on the page it links to, and no sidebar width survives
 * $68,784.45.
 *
 * "K" and "M" are cased the way CLDR compacts en-US (what `Intl`'s compact
 * notation would emit), not the SI way — uppercase both, like YouTube and X.
 */
export function formatPriceCompact(value: { amount: number; currency: string }): string {
  const dollars = Math.round(value.amount);
  const abs = Math.abs(dollars);
  if (abs < 1000) return formatPrice({ amount: dollars, currency: value.currency });
  if (abs < 1_000_000) {
    return formatPriceRounded({ amount: value.amount / 1000, currency: value.currency }) + 'K';
  }
  return formatPriceRounded({ amount: value.amount / 1_000_000, currency: value.currency }) + 'M';
}
